import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { useAppSelector } from 'store';

import { globalConst, onTrackYandexGoal } from 'modules/global';
import { topicTestsConst } from 'modules/mavzuli-test';

import { LinkWrapper } from 'components';

import { Options } from './options';
import { Question } from './question';

export const RightSide = () => {
  const { query } = useRouter();
  const questions = useAppSelector(({ topicTest }) => topicTest.test?.test[0]?.questions);
  const currentQuestionIndex = useAppSelector(({ topicTest }) => topicTest.currentQuestionIndex);
  const banner = topicTestsConst?.subjectBannerMap[query?.subject as string];

  const question = questions?.[currentQuestionIndex as number];

  return (
    <div className="sm:col-span-3">
      <AnimatePresence mode="wait">
        <motion.div
          key={question?.id}
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.25 }}
          className="space-y-3"
        >
          <Question />
          <Options />
        </motion.div>
      </AnimatePresence>

      {banner && (
        <div className="sm:h-50 h-25 !mb-22 relative z-0 my-4 w-full lg:hidden">
          <LinkWrapper
            target="_blank"
            className="z-0"
            isNotLink={banner?.isNotLink}
            onClick={() => onTrackYandexGoal(globalConst.yandexGoalKeys.rising_zone)}
            href={banner?.targetUrl || 'https://akam.uz'}
          >
            <Image
              src={banner?.mobile}
              alt="schools banner"
              title="Maktablarning banneri (reklama)"
              fill
              className="z-0 rounded-xl"
            />
          </LinkWrapper>
        </div>
      )}
    </div>
  );
};
